import { Link } from 'prismic-reactjs';

export const getAttributes = (data): { src: string, alt: string } => {
  return {
    src: Link.url(data),
    alt: data.alt,
  };
};
